export const zh = {
  title: '原生林',
  subtitle: '30m，热带地区，UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: '功能',
      value: '该数据集描绘了2001年全球泛热带地区原始森林的范围。',
    },
    {
      label: '分辨率',
      value: '30 × 30 米',
    },
    {
      label: '地理覆盖范围',
      value: '泛热带',
    },
    {
      label: '来源',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: '内容日期',
      value: 2001,
    },
  ],
  overview: {
    label: '概览',
    value:
      '原始森林是生物多样性程度最高的森林之一，可提供多种生态系统服务。因此，原始森林对于监测国家土地使用规划以及碳核算来说都是至关重要的。该数据集对原始森林的定义为：“成熟的自然湿润热带森林覆盖，在近期历史中未曾遭遇完全清除后再生。”研究人员为每个区域采用单独的算法将原始森林数据从 Landsat 卫星图像中标记出来。',
  },
  citation: {
    label: '引用',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
